import { Expenses } from './Expenses';
import { Income } from './Income';

export const IncomeAndExpenses: React.FC = () => (
    <div className="grid grid-cols-1 gap-2 xl:grid-cols-2">
        <Income />
        <Expenses />
    </div>
);
